import React from 'react';
import { Tag } from 'primereact/tag';
import 'primeicons/primeicons.css';
import { Tooltip } from 'primereact/tooltip';

// Datos de ejemplo
const entidades = [
  { nombre: 'Buro de Crédito', codigo: 'TUM', status: 'rechazado' },
  { nombre: 'Syntage', codigo: 'SYN', status: 'advertencia' },
];

// Función para mapear estado a estilo
const getEstilosPorEstado = (estado) => {
  switch (estado) {
    case true: {
      return {
        color: '#3DD598', icono: 'pi pi-check-circle',
        mensaje: 'Datos obtenidos'
      };
    };
    case 'advertencia': {
      return {
        color: '#FFC542', icono: 'pi pi-exclamation-triangle',
        mensaje: 'Datos obtenidos con advertencias'
      };
    };
    case false: {
      return {
        color: '#FF5C5C', icono: 'pi pi-times-circle',
        mensaje: 'Datos no obtenidos'
      };
    };
    default:
      return {
        color: '#C0C0C0', icono: 'pi pi-question-circle',
        mensaje: 'Sin datos'
      };
  }
};

const CustomChips = ({ data }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-around', gap: '1rem', margin: '3rem 0', flexWrap: 'wrap' }}>
    {data?.map((entidad, index) => {
      const { color, icono, mensaje } = getEstilosPorEstado(entidad.status);
      const tooltipId = `tooltip-${index}`;
      
      return (
        <React.Fragment key={index}>
          {/* Componente Tag con ID para tooltip */}
          <Tag
            id={tooltipId}
            style={{
              border: `2px solid ${color}`,
              borderRadius: '2em',
              color: color,
              backgroundColor: 'white',
              width: '300px',
              minWidth: '200px',
            }}
            value={
              <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                {`${entidad.nombre} (${entidad.codigo})`}
                <i className={icono} style={{ fontSize: '1rem' }}></i>
              </span>
            }
          />
  
          {/* Tooltip conectado por el id */}
          <Tooltip target={`#${tooltipId}`} content={mensaje} />
        </React.Fragment>
      );
    })}
  </div>
  
  );
};

export default CustomChips;
